import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

// Interfaccia per i dati delle tipologie
interface Tipologia {
    id: number;
    tipologia: string;
    seo_string: string | null;
}

// Funzione hook per recuperare le tipologie
export const useGetTipologie = () => {
    const [tipologie, setTipologie] = useState<Tipologia[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchTipologie = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/tipologie`);
                setTipologie(response.data);
                setLoading(false);
            } catch (error) {
                setError("Impossibile recuperare le tipologie");
                setLoading(false);
            }
        }
        fetchTipologie();
    }, []);

    return { tipologie, loading, error };
}

export default useGetTipologie;